import { render, staticRenderFns } from "./AdminChallengeCard.vue?vue&type=template&id=06f813c7&"
import script from "./AdminChallengeCard.vue?vue&type=script&lang=ts&"
export * from "./AdminChallengeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports